import React, { Fragment } from "react";
import { Form, Col } from "react-bootstrap";
import Cookie from "js-cookie";
import * as yup from "yup";

import GoogleAutoComplete from "../../../Common/GoogleAutoComplete/GoogleAutoComplete";
import { checkBoxes } from "./FormFields";
import axios from "../../../../service/axios";

const duplicateMailingAddress = (formValues, category) => ({
  vendorProfileId: formValues.vendorProfileId,
  duns: formValues.duns,
  email: Cookie.get("email").toLowerCase(),
  category,
  streetAddress: formValues.mailAddress.streetAddress,
  suiteUnitFloor: formValues.mailAddress.suiteUnitFloor,
  city: formValues.mailAddress.city,
  zipCode: formValues.mailAddress.zipCode,
  state: formValues.mailAddress.state,
  country: formValues.mailAddress.country,
});

export const handleFieldChange = (e, addressType, fieldName, setFormValues) => {
  e.persist();

  setFormValues((state) => {
    let saveState = {};
    const addressTypes = ["billingAddress", "shippingAddress", "rtvAddress"];
    checkBoxes.map(({ fieldId, fieldLabel, type }, index) => {
      const checked = isCheckboxSelected(
        state[addressTypes[index]],
        state.mailAddress
      );
      if (addressType === "mailAddress" && checked) {
        saveState = {
          ...saveState,
          [fieldId]: checked,
          ...saveState,
          [addressTypes[index]]: {
            ...state[addressTypes[index]],
            [fieldName]:
              fieldName === "state" ||
              fieldName === "country" ||
              fieldName === "zipCode"
                ? e.target.value.toUpperCase()
                : e.target.value,
            email: Cookie.get("email").toLowerCase(),
          },
        };
      }
    });

    return {
      ...state,
      valuesChanged:
        state.prev[addressType][fieldName] === e.target.value ? false : true,
      ...saveState,
      [addressType]: {
        ...state[addressType],
        [fieldName]:
          fieldName === "state" ||
          fieldName === "country" ||
          fieldName === "zipCode"
            ? e.target.value.toUpperCase()
            : e.target.value,
        email: Cookie.get("email").toLowerCase(),
      },
    };
  });
};

const handleCheckboxChange = (e, vendorProfile) => {
  e.persist();
  const {
    addressType,
    formValues,
    setFormValues,
    addressFields,
  } = vendorProfile;
  let errors = formValues.errors;

  let category = addressType.split("Address")[0];
  category =
    category === "rtv"
      ? category.toUpperCase()
      : category.charAt(0).toUpperCase() + category.slice(1);

  if (e.target.checked) {
    setFormValues((state) => {
      const automationId = addressFields[0].automationId;
      const saveState = {
        ...state,
        valuesChanged: true,
        validForm: validateForm({
          ...state,
          [addressType]: {
            ...state[addressType],
            ...duplicateMailingAddress(formValues, category),
          },
        }),
        [`prev${addressType}`]: { ...state[addressType] },
        [addressType]: {
          ...state[addressType],
          ...duplicateMailingAddress(formValues, category),
        },
        [e.target.name]: e.target.checked,
      };

      addressFields.forEach(({ fieldId, key }) => {
        saveState[automationId][fieldId] && delete errors[key];
      });

      return {
        ...saveState,
        errors,
      };
    });
  } else {
    setFormValues((state) => {
      const modifyAddress = state[`prev${addressType}`]
        ? {
            [addressType]: {
              ...state[`prev${addressType}`],
            },
          }
        : {
            [addressType]: {
              ...state[addressType],
              streetAddress: "",
              suiteUnitFloor: "",
              city: "",
              state: "",
              zipCode: "",
              country: "",
              email: Cookie.get("email").toLowerCase(),
            },
          };

      return {
        ...state,
        validForm: validateForm({
          ...state,
          ...modifyAddress,
        }),
        ...modifyAddress,
        [e.target.name]: e.target.checked,
      };
    });
  }
};

const isCheckboxSelected = (checkBoxAddress, compareAddress) => {
  const {
    streetAddress,
    suiteUnitFloor,
    city,
    state,
    zipCode,
    country,
  } = checkBoxAddress;
  const {
    streetAddress: value1,
    suiteUnitFloor: value2,
    city: value3,
    state: value4,
    zipCode: value5,
    country: value6,
  } = compareAddress;
  let checked = false;
  if (
    value1 === streetAddress &&
    value2 === suiteUnitFloor &&
    value3 === city &&
    value4 === state &&
    value5 === zipCode &&
    value6 === country
  ) {
    checked = true;
  }

  return checked;
};

export const renderDuplicateAddressCheckBoxes = (
  disabled,
  formValues,
  setFormValues,
  defaultAddressFields
) => {
  const addresses = [
    formValues.billingAddress,
    formValues.shippingAddress,
    formValues.rtvAddress,
  ];

  return (
    <div className="checkbox-container">
      Apply Mailing Address (above) to the following addresses:
      {checkBoxes.map(({ fieldId, fieldLabel, type }, index) => {
        const addressFields = defaultAddressFields[index + 1];
        const vendorProfile = {
          addressType: type,
          formValues,
          setFormValues,
          addressFields,
        };

        return (
          <Form.Check
            key={fieldId}
            id={fieldId}
            name={fieldId}
            label={fieldLabel}
            disabled={disabled}
            type="checkbox"
            onChange={(e) => handleCheckboxChange(e, vendorProfile)}
            checked={isCheckboxSelected(
              addresses[index],
              formValues.mailAddress
            )}
          />
        );
      })}
    </div>
  );
};

export const defaultAutoCompleteFieldChange = (e, vendorProfile) => {
  e.persist();
  const { automationId, fieldId } = vendorProfile.field;
  vendorProfile.setFormValues((state) => {
    return {
      ...state,
      valuesChanged:
        state.prev[automationId][fieldId] === e.target.value ? false : true,
      [automationId]: {
        ...state[automationId],
        [fieldId]: e.target.value,
        email: Cookie.get("email").toLowerCase(),
      },
    };
  });
};

export const defaultOnSelectAddress = (selectedAddress, vendorProfile) => {
  const { automationId } = vendorProfile.field;
  let category = automationId.split("Address")[0];

  category =
    category === "rtv"
      ? category.toUpperCase()
      : category === "mail"
      ? "Mailing"
      : category.charAt(0).toUpperCase() + category.slice(1);

  vendorProfile.setFormValues((prevState) => {
    let addresses = {};
    checkBoxes.forEach(({ fieldId, type }) => {
      type === automationId &&
        vendorProfile.setFormValues((prevState) => ({
          ...prevState,
          [fieldId]: false,
        }));

      addresses =
        prevState[fieldId] && automationId === "mailAddress"
          ? {
              ...addresses,
              [type]: {
                ...prevState[type],
                ...selectedAddress,
                suiteUnitFloor: "",
              },
              [automationId]: {
                ...prevState[automationId],
                ...selectedAddress,
                suiteUnitFloor: "",
              },
            }
          : {
              ...addresses,
              [automationId]: {
                ...prevState[automationId],
                ...selectedAddress,
                suiteUnitFloor: "",
                vendorProfileId: vendorProfile.formValues.vendorProfileId,
                duns: vendorProfile.formValues.duns,
                email: Cookie.get("email").toLowerCase(),
                category,
              },
            };
    });

    return {
      ...prevState,
      ...addresses,
      validForm: validateForm({
        ...prevState,
        ...addresses,
      }),
      errors: {},
    };
  });
};

export const SimilarAddresses = (vendorProfile) => {
  const {
    address,
    formValues,
    setFormValues,
    onChange,
    onAutoCompleteChange,
    fieldValueObject,
    onSelectAddress,
    setCoordinates,
    handleValidate,
    errors,
    disableFields,
    addressIndex,
    pageFrom = "",
    ...rest
  } = vendorProfile;
  return address.map((field, index) => {
    let {
      fieldId,
      fieldLabel,
      fieldType,
      length,
      placeHolder,
      maxLength,
      automationId,
      key,
      required,
    } = field;
    const addressType = address[0].automationId;

    return (
      <Fragment key={`${fieldId}Fragment`}>
        {fieldId.includes("streetAddress") ? (
          <Form.Group as={Col} md={length}>
            <GoogleAutoComplete
              handleValidate={handleValidate}
              errors={errors}
              field={field}
              uniqueKey={key}
              value={fieldValueObject[fieldId] || ""}
              onAutoCompleteChange={onAutoCompleteChange}
              onSelectAddress={onSelectAddress}
              setCoordinates={setCoordinates}
              formValues={formValues}
              setFormValues={setFormValues}
              disableFields={disableFields}
              addressFields={address}
              addressIndex={addressIndex}
              pageFrom={pageFrom}
            />
          </Form.Group>
        ) : (
          <>
            <Form.Group as={Col} md={length}>
              <Form.Label
                key={`${fieldId}Label`}
                id={`${fieldId}Label`}
                htmlFor={fieldId}
                style={{ color: "black", fontWeight: "500" }}
              >
                {fieldLabel}
                {required && <span className="required">*</span>}
              </Form.Label>
              <Form.Control
                key={automationId}
                id={key}
                name={fieldId}
                placeholder={placeHolder}
                autoComplete={key}
                type={fieldType}
                disabled={disableFields}
                maxLength={maxLength || ""}
                onBlur={(e) => {
                  handleValidate(
                    {
                      field,
                      fieldValue: e.target.value,
                    },
                    setFormValues,
                    formValues
                  );
                }}
                onChange={(e) => {
                  handleValidate(
                    {
                      field,
                      fieldValue: e.target.value,
                    },
                    setFormValues,
                    formValues
                  );
                  onChange(e, addressType, fieldId, setFormValues);
                }}
                value={fieldValueObject[fieldId] || ""}
              />
              {errors && errors[key] && (
                <div key={key} style={{ color: "#d64a4a" }}>
                  {errors[key]}
                </div>
              )}
            </Form.Group>
          </>
        )}
      </Fragment>
    );
  });
};

export const onAddAddress = (setFormValues, addressType, addToObject = {}) => {
  setFormValues((state) => {
    return {
      ...state,
      validForm: false,
      [addressType]: [
        ...state[addressType],
        {
          streetAddress: "",
          suiteUnitFloor: "",
          city: "",
          state: "",
          zipCode: "",
          country: "",
          addressSubType: "",
          ...addToObject,
        },
      ],
    };
  });
};

export const onDeleteAddress = (setFormValues, addressType, address, index) => {
  if (address.id) {
    axios()
      .delete("/address/deleteAddress", { data: address })
      .then((res) => {
        setFormValues((state) => {
          let address = [...state[addressType]];
          address.splice(index, 1, "");
          address = address.filter((item) => item !== "");

          return {
            ...state,
            valuesChanged: true,
            errors: {},
            validForm: validateForm({ ...state, [addressType]: address }),
            [addressType]: address,
          };
        });
      })
      .catch((err) =>
        setFormValues((state) => ({
          ...state,
          requestErrorMessage: `Unable to delete ${address.category} address.`,
        }))
      );
  } else {
    setFormValues((state) => {
      let address = [...state[addressType]];
      address.splice(index, 1, "");
      address = address.filter((item) => item !== "");

      return {
        ...state,
        errors: {},
        valuesChanged: true,
        validForm: validateForm({ ...state, [addressType]: address }),
        [addressType]: address,
      };
    });
  }
};

export const validateZipCode = (value, cb) => {
  if (!value) {
    return false;
  }
  switch (value.length) {
    case 5:
      return cb ? cb(value, /(\d{5})$/g) : value.match(/(\d{5})$/g);
    case 6:
      return cb
        ? cb(value, /^([A-Z]\d[A-Z]\d[A-Z]\d)$/g)
        : value.match(/^([A-Z]\d[A-Z]\d[A-Z]\d)$/g);
    case 7:
      return cb
        ? cb(value, /^([A-Z]\d[A-Z]\s\d[A-Z]\d)$/g)
        : value.match(/^([A-Z]\d[A-Z]\s\d[A-Z]\d)$/g);
    case 10:
      return cb
        ? cb(value, /(\d{5})[-](\d{4})/g)
        : value.match(/(\d{5})[-](\d{4})/g);
    default:
      return false;
  }
};

export const validationSchema = yup.object({
  streetAddress: yup.string().required("Field is required"),
  suiteUnitFloor: yup.string().nullable(),
  city: yup
    .string()
    .test("Test digits", "e.g New York", (value) =>
      value.match(/^[a-zA-Z\- ]+$/g)
    )
    .required("Field is required"),
  cityShipping: yup
    .string()
    .test("Test digits", "e.g New York", (value) =>
      value.match(/^[a-zA-Z\s!@#\$%\^\&*\)\(+=._-]+$/g)
    )
    .required("Field is required"),
  state: yup
    .string()
    .test("Test digits", "Capital letters only", (value) =>
      value.match(/^[A-Z ]+$/i)
    )
    .min(2, "Must be 2 characters.")
    .required("Field is required"),
  zipCode: yup
    .string()
    .test({
      name: "zipCodePattern",
      message: "e.g 10001, 10001-9999, A1A 1A1, A1A1A1",
      test: (value) => {
        return validateZipCode(value);
      },
    })
    .required("Field is required"),
  country: yup
    .string()
    .test("Test digits", "Capital letters only", (value) =>
      value.match(/^[A-Z]+$/i)
    )
    .min(2, "Must be 2 characters.")
    .required("Field is required"),
  addressSubType: yup
    .string()
    .required("Field is required")
    .matches(/^[A-Za-z0-9 ]+$/i, "Letters and numbers only"),
  upsAccountNumber: yup
    .string()
    .min(
      6,
      "Invalid UPS account format: UPS account must contain six letters and/or numbers."
    )
    .test({
      name: "upsAccountNumberPattern",
      message:
        "Invalid UPS account format: UPS account must contain six letters and/or numbers.",
      test: (value) => {
        return value.match(/^[A-Z0-9]*$/g) && !value.match(/^[0]{6}$/g);
      },
    })
    .required("Field is required"),
});

export const handleValidate = (fieldInfo, setFormValues) => {
  const { field, fieldValue } = fieldInfo;

  yup
    .reach(validationSchema, `${[field.fieldId]}`)
    .validate(fieldValue)
    .then((value) => {
      setFormValues((state) => {
        state.errors[field.key] && delete state.errors[field.key];

        return {
          ...state,
          validForm: validateForm(state),
        };
      });
    })
    .catch((err) => {
      setFormValues((state) => ({
        ...state,
        errors: {
          ...state.errors,
          [field.key]: err.message,
        },
      }));
    });
};

export const validateForm = (formValues) => {
  let validForm = true;
  const otherAddress = formValues?.otherAddress
    ? [...formValues.otherAddress]
    : [];

  let addresses = [
    formValues.mailAddress,
    formValues.shippingAddress,
    formValues.billingAddress,
    formValues.rtvAddress,
  ];

  const checkFields = [
    "streetAddress",
    "city",
    "state",
    "zipCode",
    "country",
    "addressSubType",
  ];

  if (otherAddress && otherAddress.length > 0) {
    otherAddress.map((address, index) => {
      Object.keys(address).forEach((field) => {
        if (checkFields.includes(field)) {
          if (address[field] === "") {
            validForm = false;
          }
        }
      });
    });
  }

  addresses.map((address, index) => {
    Object.keys(address).forEach((field) => {
      if (checkFields.includes(field)) {
        if (address[field] === "") {
          validForm = false;
        }
      }
    });
  });

  return validForm;
};

export const consturctAddressState = (vendorProfile) => {
  let addresses = {};
  const commonProperties = {
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    vendorProfileId: vendorProfile?.vendorDetail?.id,
    duns: vendorProfile?.vendorDetail?.duns,
    email: Cookie.get("email").toLowerCase(),
  };

  const addressTypes = [
    { category: "Mailing", type: "mailAddress" },
    { category: "Shipping", type: "shippingAddress" },
    { category: "Billing", type: "billingAddress" },
    { category: "RTV", type: "rtvAddress" },
  ];

  addressTypes.forEach(({ category, type }) => {
    addresses = {
      ...addresses,
      [type]: vendorProfile[type] || { ...commonProperties, category },
    };
  });

  return addresses;
};

export const objectEmpty = (obj) => JSON.stringify(obj) === "{}";
